import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/HOME/Index.vue'
import Dorm from '@/components/DORM/Index.vue'
import Staff from '@/components/STAFF/Index.vue'
import Students from '@/components/STUDENTS/Index.vue'
import News from '@/components/News/Index.vue'
import NewsId from '@/components/NewsId/Index.vue'
import VueRouter from 'vue-router'

Vue.use(Router)


  const routes = [
    {
      path: '/',
      redirect: '/th/home'
    },
    {
      path: '/:lang/home',
      name: 'home',
      component: Homepage
    },
    {
      path: '/:lang/dorm',
      name: 'dorm',
      component: Dorm
    },
    {
      path: '/:lang/staff',
      name: 'staff',
      component: Staff
    },
    {
      path: '/:lang/student',
      name: 'student',
      component: Students
    },
    {
      path: '/:lang/news',
      name: 'news',
      component: News
    },
    {
      path: '/:lang/news/:newsId',
      name: 'newsById',
      props: true,
      component: NewsId
    }
  ]
  const router = new VueRouter({
    mode: 'history',
    base: '/GiftEd/',//process.env.BASE_URL,
    routes
  })


export default router



// WEBPACK FOOTER //
// ./src/router/index.js